import { Box } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .SDAArrow': {
    position: 'absolute',
    top: theme.spacing(0.5),
    color: theme.palette.grey[300],
    backgroundColor: 'transparent',
    border: '0px',
    padding: 0,
    minWidth: 'unset',
    '&.SDALeftArrow': {
      left: theme.spacing(-5),
    },
    '&.SDARightArrow': {
      right: theme.spacing(-4),
    },
    '& .MuiSvgIcon-root': {
      fontSize: theme.spacing(4),
    },
  },
}));

export default StyledBox;
